import { designTypeLabel, isPackageTransport } from "./packageTransport";

// Pakettransport (Welle 6): Der Snapshot benennt das ganze Paket je Werk um, unabhängig von der Auswahl. Deshalb zählen
// alle Änderungen des Vergleichs, auch die der Designobjekte; ein reines Designpaket hat keine Zeilenauswahl.
export function selectedPlantChanges(state) {
  const result = new Map();
  const whole = isPackageTransport(state);
  for (const entry of Object.values(state.precheckByBucket || {})) {
    if (!entry || entry.error) continue;
    const plant = entry.werk?.kennung || "std";
    const plantKey = (state.space?.werkeList || []).find(item => item.kennung === plant)?.key || plant;
    const selected = (entry.comparison || []).filter(a => !a.draft &&
      (state.sel?.[a.originalId || a.Id]?.[plant] || state.sel?.[a.originalId || a.Id]?.[plantKey]));
    if (!whole && !selected.length) continue;
    const rows = whole ? (entry.comparison || []) : selected;
    // Der Server führt Designobjekte als kind "artifact"; der Typ macht sie in der Bestätigung erkennbar.
    const design = whole ? (entry.designArtifacts || []).flatMap(d => (d?.plantChanges || [])
      .map(change => ({ ...change, designType: designTypeLabel(d.type || d.Type) || undefined }))) : [];
    for (const change of [...(entry.plantChanges || []), ...rows.flatMap(a => a.plantChanges || []), ...design])
      result.set(change.key, { ...change, targetInstance: entry.instance?.name || entry.instance?.id || "" });
  }
  return [...result.values()];
}

// DEV181 (Regel „nur GitHub lehnt ab“): Der Wechsel der Werkskennung ist eine Information, keine Pflichtbestätigung. Die
// Funktion bleibt für die Aufrufer bestehen und sperrt nie.
export function plantChangesConfirmed() {
  return true;
}
// Titel der Information: genau ein Zielwerk nennt es mit seiner Kennung, sonst allgemein.
export function plantChangeTargets(changes) {
  return [...new Set((changes || []).map(change => change.to).filter(Boolean))];
}
